
























import Vue from 'vue'
import OptOutSaleAction from '@/components/OptOutSaleAction.vue'
import RequestInfoAction from '@/components/RequestInfoAction.vue'
import StartDeletionAction from '@/components/StartDeletionAction.vue'

export default Vue.extend({
  name: 'Privacy',
  components: {
    OptOutSaleAction,
    RequestInfoAction,
    StartDeletionAction
  }
})
